import {CDSCoordinates, ChromosomalCoords} from 'import-sequence/ImportSequenceConstants';

// Example input:
//   10-100,200-300
//   1-2
const COORD_REGEX = /(?:(\d+)\s*-\s*(\d+))/g;

export function strToSeqIndex(str: string): number {
  return parseInt(str, 10);
}

export function parseCoordinates(coordString: string): Array<CDSCoordinates> {
  // Take in a string of coords <start>-<end> seperated by commas and return an array of tuples
  const coords = [];
  let match = COORD_REGEX.exec(coordString);
  while (match != null) {
    const [start, end] = match.slice(1, 3);
    coords.push({start: strToSeqIndex(start), end: strToSeqIndex(end), displayCoords: true});
    match = COORD_REGEX.exec(coordString);
  }
  return coords;
}

// Example input:
//   chr1.name : 1 - 100
//   chr1.name:1-100 10-200,300-400
//   chr12name : 1 - 100 10-200,300-400
//   chr12name : 1 - 100 10 - 200, 300 - 400
export const CHROMOSOME_COORD_REGEX = new RegExp(
  '^([\\w.]+)' + // Chromosome name at start
    '\\s*:\\s*' + // Colon separator with optional spaces
    '(\\d+)' + // Chromosome start coordinate
    '\\s*-\\s*' + // Hyphen separator with optional spaces
    '(\\d+)' + // Chromosome end coordinate
    '(?:' + // Non-capturing group for optional CDS coordinates
    '\\s+' + // Must have spaces before optional CDS coordinates
    '(' +
    '\\d+\\s*-\\s*\\d+' + // First CDS coordinate
    '(?:,\\s*\\d+\\s*-\\s*\\d+)*' + // Additional CDS coordinates must start with a comma
    ')' +
    ')?' + // CDS coordinates are optional
    '\\s*$' // Optional trailing spaces
);

export function parseChromosomeCoordinates(lines: Array<string>): Array<ChromosomalCoords> | null {
  if (!lines.every((line) => CHROMOSOME_COORD_REGEX.test(line))) {
    return null;
  }

  // Map each line to an object of `name, start, end, coordString`
  return lines.map((line) => {
    const match = CHROMOSOME_COORD_REGEX.exec(line);
    const [name, start, end, coordString] = match!.slice(1, 5);
    const cdsCoords = parseCoordinates(coordString ?? '');
    return {
      name,
      start: strToSeqIndex(start),
      end: strToSeqIndex(end),
      cdsCoords,
    };
  });
}
